<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="租户编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                style="width: 100%"
                :min="1"
                v-decorator="['id', { rules: [{ required: true, message: '请输入租户编号' }] }]"
                placeholder="请输入租户编号"
              ></a-input-number>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="租户名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name']" placeholder="请输入租户名称"></a-input>
            </a-form-item>
          </a-col>

          <a-col v-if="Object.keys(this.model).length" :span="24">
            <a-col :span="12">
              <a-form-item
                label="推送提醒日期"
                :labelCol="{
                  xs: { span: 24 },
                  sm: { span: 10 },
                }"
                :wrapperCol="{
                  xs: { span: 24 },
                  sm: { span: 14 },
                }"
              >
                <j-dict-select-tag
                  style="width: 100%"
                  dict-code="dayOfWeekAll"
                  v-model="model.dayOfWeekWarn"
                  placeholder="请选择推送提醒日期"
                />
              </a-form-item>
            </a-col>
            
            <a-col :span="12">
              <a-form-item
                label="提醒时间"
                :labelCol="{
                  xs: { span: 24 },
                  sm: { span: 6 },
                }"
                :wrapperCol="{
                  xs: { span: 24 },
                  sm: { span: 12 },
                }"
              >
                <a-time-picker format="HH:mm" v-model="model.pushTime" style="width: 100%" />
              </a-form-item>
            </a-col>
          </a-col>
          <a-col :span="24" class="aCol" v-if="Object.keys(this.model).length">
            <span class="spanCol">*</span>
            <a-form-item
              label="选择预警模型"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
            <!-- @input="modelInput" -->
              <j-dict-select-tag
                style="width: 100%"
                :isShowEmpty="false"
                dict-code="push_model"
                :allowClear="false"
                v-model="model.pushModel"
                placeholder="请选择预警模型"
                :key="model.id"
              />
            </a-form-item>

          </a-col>

          <a-col :span="24">
            <a-form-item label="经度" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                style="width: 100%"
                v-decorator="['lng']"
                placeholder="请输入经度"
              ></a-input-number>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="纬度" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                style="width: 100%"
                v-decorator="['lat']"
                placeholder="请输入纬度"
              ></a-input-number>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="appKey" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                style="width: 100%"
                v-decorator="['appKey']"
                placeholder="请输入appKey"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="appSecret" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                style="width: 100%"
                v-decorator="['appSecret']"
                placeholder="请输入appSecret"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="corpId" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                style="width: 100%"
                v-decorator="['corpId']"
                placeholder="请输入corpId"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="agentId" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                style="width: 100%"
                v-decorator="['agentId']"
                placeholder="请输入agentId"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="照片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload v-decorator="['pic']" bizPath="studentFace"></j-image-upload>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-radio-group name="tenantStatus" v-decorator="['status', { initialValue: 1 }]">
                <a-radio :value="1">正常</a-radio>
                <a-radio :value="0">冻结</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="机构" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                v-model="model.orgId"
                placeholder="请选择机构"
                dictCode="school_org,name,id"
              />
            </a-form-item>
          </a-col>

          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import pick from 'lodash.pick'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JImageUpload from '@/components/jeecg/JImageUpload'
import moment from 'moment'
import { ajaxGetDictItems,getDictItemsFromCache } from '@/api/api'

export default {
  name: 'TenantForm',
  components: {
    JFormContainer,
    JDate,
    JDictSelectTag,
    JImageUpload,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
      required: false,
    },
    normal: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/sys/tenant/add',
        // edit: '/sys/tenant/edit',
        edit: '/sys/tenant/editTenant',
        queryById: '/sys/tenant/queryById',
      },
      dictCode:"push_model"
    }
  },
  computed: {
    formDisabled() {
      if (this.normal === false) {
        if (this.formData.disabled === false) {
          return false
        } else {
          return true
        }
      }
      return this.disabled
    },
    showFlowSubmitButton() {
      if (this.normal === false) {
        if (this.formData.disabled === false) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
  },
  created() {
    this.showFlowData()
  },
  methods: {
    add() {
      this.edit({})
      this.model = {}
    },
    edit(record) {
      this.form.resetFields()
      if (record?.pushTime) {
        record.pushTime = moment(record.pushTime, 'HH:mm')
      }
      
      this.model = Object.assign({}, record)
      
      // 给预警模型赋值,因为不允许默认数据是空
      //优先从缓存中读取字典配置
      if (getDictItemsFromCache(this.dictCode)) {
        this.dictOptions = getDictItemsFromCache(this.dictCode)
            if(!record.pushModel){
              this.model.pushModel = this.dictOptions[0]?.value
            }
      }else{
        ajaxGetDictItems(this.dictCode, null).then((res) => {
          if (res.success) {
            this.dictOptions = res.result
            if(!record.pushModel){
              this.model.pushModel = this.dictOptions[0]?.value
            }
          }
        })
      }


      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'id',
            'name',
            'lng',
            'lat',
            'status',
            'pic',
            'appKey',
            'appSecret',
            'agentId',
            'corpId',
            'orgId',
            'pushModel'
          )
        )
      })
    },
    showFlowData() {
      if (this.normal === false) {
        let params = { id: this.formData.dataId }
        getAction(this.url.queryById, params).then((res) => {
          if (res.success) {
            this.edit(res.result)
          }
        })
      }
    },
    // changeBeginTime(time, timeString) {
    //   this.model.pushTime = timeString
    // },
    submitForm() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          if (!this.model.orgId) {
            values.orgId = ''
          }
          if (this.model?.pushTime) {
            this.model.pushTime = moment(this.model.pushTime).format('HH:mm')
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    popupCallback(row) {
      this.form.setFieldsValue(pick(row, 'id', 'name', 'beginDate', 'endDate', 'status'))
    },
  },
}
</script>

<style lang="less" scoped>

.aCol{
  position:relative;
  .spanCol{
    color: red;
    position: absolute;
    left: 50px;
    top: 11px;
  }
}

</style>
